export default {
  "1": {
    text: "Welche kosmetische Behandlung möchten Sie vornehmen lassen?",
    type: "checkbox",
    showSonstiges: true,
    options: [
      {
        value: "Veneer",
      },
      {
        value: "Schienentherapie",
      },
      // {
      //   value: "Sonstiges",
      // },
    ],
    info:
      "Alle Behandlungen müssen im Rahmen der kassenärztlichen Versorgung erfolgen, also von Zahnärzten oder Kieferorthopäden mit Kassenzulassung durchgeführt und im Rahmen der kassenärztlichen Vorschriften abgerechnet werden. Demnach sind privatärztliche Rechnungen nach der Gebührenordnung für Zahnärzte (GOZ) nur dann erstattungsfähig, wenn die medizinisch notwendigen Maßnahmen von Zahnärzten oder Kieferorthopäden mit Kassenzulassung durchgeführt werden und nicht im Rahmen der kassenärztlichen Versorgung abgerechnet werden können. Da sich die ARAG nur an Kosten von medizinischen Heilbehandlungen beteiligen kann, ist eine Erstattung für kosmetische kieferorthopädische Behandlungen nicht möglich.",
  },
};
